export const LOADING = 'LOADTING';


// WEBPACK FOOTER //
// ./src/constants/Login.tsx